import type { PodcastSummary } from './types'

type Props = {
  podcast: PodcastSummary
  selected: boolean
  onClick: () => void
}

export default function PodcastResultCard({ podcast, selected, onClick }: Props) {
  return (
    <button
      type="button"
      className={`podcast-result-card${selected ? ' podcast-result-card--selected' : ''}`}
      onClick={onClick}
    >
      {podcast.thumbnail && (
        <img
          src={podcast.thumbnail}
          alt=""
          className="podcast-result-card__thumb"
          loading="lazy"
        />
      )}
      <div className="podcast-result-card__body">
        <h3 className="podcast-result-card__title">{podcast.title}</h3>
        <p className="podcast-result-card__publisher">{podcast.publisher}</p>
        {podcast.description && (
          <p className="podcast-result-card__description">{podcast.description}</p>
        )}
      </div>
    </button>
  )
}
